import { RootState } from '@reducers';

export const selectHealthQuoteBuyRoute = (state: RootState) => state.healthQuoteBuyRouteReducer;
